/**
 * Store Module - StoreHome Page
 * 
 * Página principal del módulo de tienda
 */
export default function StoreHome() {
  return (
    <div className="px-4 py-6 sm:px-0">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-tf-text mb-4">
          Tienda NextStore
        </h1>
        <p className="text-lg text-tf-text-muted mb-8">
          Explora nuestros productos
        </p>
        <div className="bg-tf-bg-card shadow rounded-lg p-6">
          <h2 className="text-2xl font-semibold text-tf-text mb-4">
            Módulo Store
          </h2>
          <ul className="text-left space-y-2 text-tf-text-muted">
            <li>✅ Catálogo de productos</li>
            <li>✅ Carrito de compras</li>
            <li>✅ Proceso de checkout</li>
            <li>✅ Gestión de pedidos</li>
          </ul>
        </div>
      </div>
    </div>
  )
}













